import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { fetchTermsContent } from './Redux/thunks';
import InfoTermsPage from 'Pages/InfoTermsPage/InfoTermsPage';
import { getIsFetching, getTermsContent } from './Redux/selectors';

interface IPropsInternal {
  isFetching: boolean;
  content: Julius.Website.TermsPageViewModel;
  fetchTermsContent: () => void;
}

type Props = IPropsInternal;

class InfoTermsPageContainer extends React.PureComponent<Props> {

  componentDidMount() {
    this.props.fetchTermsContent();
  }

  render() {
    return (
      <InfoTermsPage 
        isFetching={ this.props.isFetching }
        content={ this.props.content }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isFetching: getIsFetching(state),
    content: getTermsContent(state),
  }
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchTermsContent,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(InfoTermsPageContainer);


// WEBPACK FOOTER //
// ./src/pages/InfoTermsPage/InfoTermsPageContainer.tsx